
        import Symbol from "../../../svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-material-key",
  "use": "icon-material-key-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" id=\"icon-material-key\"><path d=\"M280.06-409.37q-29.02 0-49.85-20.78-20.84-20.77-20.84-49.79t20.78-49.85q20.77-20.84 49.79-20.84t49.85 20.78q20.84 20.77 20.84 49.79t-20.78 49.85q-20.77 20.84-49.79 20.84M280-234.5q-102.07 0-173.79-71.73Q34.5-377.96 34.5-480.06q0-102.09 71.71-173.77Q177.93-725.5 280-725.5q73.91 0 129.35 34.96 55.43 34.95 86.45 104.91h355.03L966.7-470 795.87-313.17l-88.24-64.48-87.76 63.76-75.96-60.48h-48.13q-25 60.72-79.89 100.29Q360.99-234.5 280-234.5m0-65.5q58.72 0 107.84-39.1t62.64-100.53h117.11l53.04 44.28 88-63 82 61.52 82.13-74.45-48.85-49.09H450.48q-11.28-56.96-59.67-98.29Q342.43-660 280-660q-75 0-127.5 52.5T100-480t52.5 127.5T280-300\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-material-key"/>
                </svg>
            );
        };

        Icon.id = "icon-material-key";

        export default Icon;
    